/* Warenkorbseite Kaufen / Leasen (seit 2026-09-30)
   Zustand liegt in localStorage „rachow-leasing“ und wird von der Leasing-Formularseite gelesen:
   { mode: 'buy'|'lease', partner: 'jobrad', ownsLock: true } */
(function () {
  'use strict';
  var KEY = 'rachow-leasing';
  var eur = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return eur.format((Number(cents) || 0) / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  var partners = [];
  try { partners = JSON.parse(document.getElementById('rachow-leasing-partners').textContent); } catch (e) {}
  var byKey = {}; partners.forEach(function (p) { byKey[p.key] = p; });

  var state = load();
  var params = new URLSearchParams(location.search);
  if (params.get('mode') === 'leasing' || params.get('mode') === 'lease') state.mode = 'lease';
  if (params.get('partner') && byKey[params.get('partner')]) state.partner = params.get('partner');
  save(state);

  function root() { return document.querySelector('[data-rc-cart]'); }

  function items() {
    return Array.prototype.map.call(document.querySelectorAll('.rc-item'), function (el) {
      return {
        el: el,
        title: (el.querySelector('.rc-item__title') || {}).textContent || '',
        line: Number(el.dataset.line),
        qty: Number(el.dataset.qty),
        linePrice: Number(el.dataset.linePrice),
        unitPrice: Number(el.dataset.unitPrice),
        bike: el.dataset.bike === 'true',
        lock: el.dataset.lock === 'true',
        excluded: el.dataset.excluded === 'true'
      };
    });
  }

  function lockLink(p) {
    var r = root();
    return '/collections/' + (r.dataset.lockCollection || 'schlosser') + '?filter.v.price.gte=' + (p ? p.lockMin : 48);
  }

  /* ---------- Rendering ---------- */
  function applyMode() {
    var r = root(); if (!r) return;
    var lease = state.mode === 'lease';
    r.classList.toggle('is-lease', lease);
    r.querySelectorAll('.rc-mode__opt').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.mode === (lease ? 'lease' : 'buy'))); });
    var buy = r.querySelector('[data-panel="buy"]'); var ls = r.querySelector('[data-panel="lease"]');
    if (buy) buy.hidden = lease;
    if (ls) ls.hidden = !lease;
    if (lease) evaluate();
  }

  function fillSelect() {
    var sel = document.querySelector('[data-partner-select]'); if (!sel) return;
    sel.innerHTML = '<option value="">Partner wählen …</option>' + partners.map(function (p) {
      return '<option value="' + esc(p.key) + '"' + (p.key === state.partner ? ' selected' : '') + '>' + esc(p.label) + '</option>';
    }).join('');
  }

  function logoHtml(p) {
    return p.logo
      ? '<img class="rc-partner__logo" src="' + esc(p.logo) + '" alt="' + esc(p.label) + '" loading="lazy">'
      : '<span class="rc-partner__word">' + esc(p.label) + '</span>';
  }

  function evaluate() {
    var box = document.querySelector('[data-partner-info]'); if (!box) return;
    var p = byKey[state.partner];
    var list = items();
    var total = list.reduce(function (s, i) { return s + i.linePrice; }, 0);
    var totalEl = document.querySelector('[data-lease-total]'); if (totalEl) totalEl.textContent = money(total);

    var reasons = [];
    var hasBike = list.some(function (i) { return i.bike; });
    var excluded = list.filter(function (i) { return i.excluded; });
    if (!hasBike) reasons.push('Kein Fahrrad oder E-Bike im Warenkorb.');
    if (!p) reasons.push('Bitte wähle zuerst deinen Leasing-Partner.');
    if (excluded.length) reasons.push('Bitte entferne Artikel, die nicht geleast werden können.');

    var html = '';
    if (!hasBike) {
      html += '<div class="rc-note rc-note--warn"><strong>Kein Fahrrad im Warenkorb</strong><p>Geleast werden kann nur ein Fahrrad oder E-Bike' +
        (p && p.minSum ? ' – bei ' + esc(p.label) + ' mit einem Warenkorbwert ab ' + money(p.minSum * 100) : '') +
        '. Zubehör wie ein Schloss kannst du zusammen mit dem Rad mitleasen.</p>' +
        '<a class="rc-note__link" href="/collections/e-bikes">E-Bikes ansehen <span aria-hidden="true">→</span></a>' +
        '<a class="rc-note__link" href="/collections/fahrrader">Fahrräder ansehen <span aria-hidden="true">→</span></a></div>';
    }
    if (p) {
      html += '<div class="rc-partner">' + logoHtml(p) + '<ul>' + p.facts.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') +
        '</ul></div>';

      if (hasBike && p.minSum && total < p.minSum * 100) {
        reasons.push('Die Mindestleasingsumme von ' + money(p.minSum * 100) + ' ist noch nicht erreicht.');
        html += '<div class="rc-note rc-note--warn"><strong>Mindestleasingsumme nicht erreicht</strong><p>Bei ' + esc(p.label) + ' muss der Warenkorb mindestens ' + money(p.minSum * 100) + ' betragen. Aktuell: ' + money(total) + '.</p></div>';
      }
      if (p.notice) {
        html += '<div class="rc-note rc-note--' + (p.notice.tone === 'warn' ? 'warn' : 'info') + '"><strong>' + esc(p.notice.title) + '</strong><p>' + esc(p.notice.text) + '</p></div>';
      }

      var lockInCart = list.filter(function (i) { return i.lock && i.unitPrice >= p.lockMin * 100; })[0];
      var smallLock = list.filter(function (i) { return i.lock && i.unitPrice < p.lockMin * 100; })[0];
      var cbText = p.lockCheckbox || ('Ich besitze bereits ein Fahrradschloss im Wert von mind. ' + p.lockMin + ' €.');
      var lockText = 'Bitte füge dem Warenkorb ein Schloss im Wert von mind. ' + p.lockMin + ' € hinzu, welches deinen Leasingvorgaben entspricht.';
      var link = '<a class="rc-note__link" href="' + lockLink(p) + '">Schloss zum Warenkorb hinzufügen <span aria-hidden="true">→</span></a>';

      if (!hasBike) {
        /* ohne Rad keine Schloss-Prüfung */
      } else if (lockInCart) {
        html += '<div class="rc-note rc-note--ok"><strong>Schloss-Anforderung erfüllt</strong><p>' + esc(lockInCart.title.trim()) + ' ist im Warenkorb.</p></div>';
      } else if (p.lockMode === 'required') {
        reasons.push('Bei ' + p.label + ' muss ein Schloss (mind. ' + p.lockMin + ' €) im Warenkorb liegen.');
        html += '<div class="rc-note rc-note--alert">' + lockIcon() + '<strong>Schloss erforderlich</strong><p>' + lockText +
          (smallLock ? ' Das Schloss im Warenkorb liegt unter diesem Wert.' : '') + '</p>' + link + '</div>';
      } else if (state.ownsLock) {
        html += '<div class="rc-note rc-note--ok"><strong>Schloss-Anforderung erfüllt</strong>' + checkbox(cbText, true) + '</div>';
      } else {
        reasons.push('Bitte füge ein Schloss hinzu oder bestätige, dass du bereits eins besitzt.');
        html += '<div class="rc-note rc-note--hint">' + lockIcon() + '<strong>' + (p.lockMode === 'necessary' ? 'Schloss notwendig' : 'Schloss empfohlen') + '</strong><p>' + lockText + '</p>' + link + checkbox(cbText, false) + '</div>';
      }
    }
    box.innerHTML = html;

    var go = document.querySelector('[data-lease-go]');
    var msg = document.querySelector('[data-block-msg]');
    if (go) go.disabled = reasons.length > 0;
    if (msg) { msg.hidden = !((p || !hasBike) && reasons.length); msg.textContent = reasons[0] || ''; }
  }

  function lockIcon() {
    return '<svg class="rc-note__ico" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></g></svg>';
  }
  function checkbox(text, checked) {
    return '<label class="rc-check"><input type="checkbox" data-owns-lock' + (checked ? ' checked' : '') + '><span>' + esc(text) + '</span></label>';
  }

  /* ---------- Warenkorb ändern ---------- */
  var busy = false;
  function change(line, quantity) {
    if (busy) return; busy = true;
    var r = root(); if (r) r.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) { return res.json(); })
      .then(function () { return rerender(); })
      .catch(function () { location.reload(); })
      .finally(function () { busy = false; var r2 = root(); if (r2) r2.classList.remove('is-busy'); });
  }

  function rerender() {
    var r = root(); if (!r) return Promise.resolve();
    var id = r.dataset.sectionId;
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-rc-cart]');
        if (!fresh) { location.reload(); return; }
        r.replaceWith(fresh);
        setup();
      });
  }

  /* ---------- Events (einmalig, per Delegation) ---------- */
  document.addEventListener('click', function (e) {
    if (!root()) return;
    var opt = e.target.closest('.rc-mode__opt');
    if (opt) { state.mode = opt.dataset.mode === 'lease' ? 'lease' : 'buy'; save(state); applyMode(); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { var it = rm.closest('.rc-item'); if (it) change(Number(it.dataset.line), 0); return; }
    var go = e.target.closest('[data-lease-go]');
    if (go && !go.disabled) {
      state.mode = 'lease'; save(state);
      location.href = root().dataset.leasingPage || '/pages/leasing-anfrage';
    }
  });

  document.addEventListener('change', function (e) {
    if (!root()) return;
    if (e.target.matches('[data-qty-select]')) {
      var it = e.target.closest('.rc-item'); if (it) change(Number(it.dataset.line), Number(e.target.value));
    } else if (e.target.matches('[data-partner-select]')) {
      state.partner = e.target.value; save(state); evaluate();
    } else if (e.target.matches('[data-owns-lock]')) {
      state.ownsLock = e.target.checked; save(state); evaluate();
    }
  });

  function setup() { fillSelect(); applyMode(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
